export const SITESPECT_EXPERIMENT = {
	VARIANT: 'variant',
	CONTROL: 'control',
};

export const SITESPECT_EXPERIMENT_NAMES = {
	TRIAL_EXPERIMENT: 'trialExperiment',
	CANCELLATION_FORM_EXPERIMENT: 'cancellationFormExperiment',
	CANCELLATION_FORM_EXPERIMENT_PRICE: 'cancellationFormExperimentPrice',
	CANCELLATION_MODAL_EXPERIMENT: 'cancellationModalExperiment',
	CHANGE_TIER_EXPERIMENT: 'changeTierExperiment',
	SAVOD: 'savod',
	SAVOD_CHANGE_TIER_EXPERIMENT: 'savodChangeTierExperiment',
	REGISTER_EXPERIMENT: 'registerExperiment',
	TRIAL_PERIOD_EXPERIMENT: 'trialPeriodExperiment',
	BIGGER_TIER_CARDS: 'biggerTierCards',
};
